// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/fup-user-schema',
  type: 'object',
  required: [],
  nullable: true,
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    organisationId: {
      type: 'string',
      format: 'uuid',
      nullable: true,
    },
    organisationGenericName: {
      type: 'string',
      nullable: true,
    },
    email: {
      type: 'string',
      nullable: true,
    },
    lastName: {
      type: 'string',
      nullable: true,
    },
    firstName: {
      type: 'string',
      nullable: true,
    },
    userName: {
      type: 'string',
      nullable: true,
    },
    lastLoginDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    lastActivityDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
